<script>
  import {ignore} from "../../../Common/tools";
  import {External, M} from "../../../external";

  export let data;
  export let valid;
  export let onChange = ignore;

  let groups = [];
  if (!data) {
    data = {};
  }
  if (!data.settings) {
    data.settings = data.settings || [];
  }

  const selectMemberGroups = () => {
    let selectedGroups = data.settings.map((setting) => External.getById(External.Website.memberGroups, setting.key, false)).filter((group) => !!group);

    External.Tools.chooseMultiple({
      title: M.SELECT_MEMBER_GROUPS,
      message: '',
      noItemsMessage: M.NO_MEMBER_GROUPS,
      items: External.Website.memberGroups,
      selectedItems: selectedGroups,
      isModal: true,
      getItemId: (group) => {
        return group.id;
      },
      getItemText: (group) => {
        return group.name;
      },
      onSelect: (newGroups) => {
        if (newGroups.length === 0) {
          External.Tools.showError(M.ERR_SELECT_MEMBER_GROUPS);
          return;
        }

        data.settings = newGroups.map((group) => {
          return {key: String(group.id), value: String(group.name)};
        });

        data.name = data.settings.map((setting) => setting.value).join(", ");
        valid = data.settings && data.settings.length > 0;
        onChange();
      }
    });
  };
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.TRIGGER_MEMBER_GROUP_ADD}</h4>
  <div class="multiple-items-picker mt-25 mb-5">
    <ul class="groups category-groups mb-15">
      <li>
        <a on:click={selectMemberGroups} rel="action" data-action="editProductCategories" class="middle-button gray">{M.SELECT_GROUPS}</a>
      </li>
      <li>{data.settings.length} {data.settings.length === 1 ? M.SINGLE_GROUP : M.GROUPS} {M.SELECTED}</li>
    </ul>
  </div>
</div>
